import EventManager from 'dd-event-manager';



const BARRAGE_SAFE_INTERVAL = 500;



export default {
  props: {
    screen: {
      type: [Array, String],
      default: null,
    },
    type: {
      type: [Array, String],
      default: null,
    },
    firstIndex: {
      type: [Number, String],
      default: 'random',
    },
    size: {
      type: [Object],
      default: null,
    },
    forceMq: {
      type: String,
      default: null,
    },
    onMq: {
      type: Function,
      default: () => {},
    },
    onExist: {
      type: Function,
      default: () => {},
    },
    onBeforeDestroy: {
      type: Function,
      default: () => {},
    },
    onDestroyed: {
      type: Function,
      default: () => {},
    },
    visibilityJudge: {
      type: Number,
      default: 1,
    },
    expelFixed: Boolean,
  },

  data() {
    return {
      count: 0,
      needs: 1,
      index: null,
      items: [],
      _before: null,
      isPause: false,
      visible: {width: 0, height: 0},
      barrageSafeTimerId: null,
      clickDisabled: false,
    }
  },

  computed: {
    mq() { return this.forceMq || this.$store.getters['banner/mq/current'] },
    typeSetting() { return this.$store.getters['banner/config/typeSetting'](this.type) },
    rotateInterval() {
      const typeSetting = this.typeSetting;
      return typeSetting && typeSetting.interval && typeSetting.interval * 1000 || 5000;
    },
    condition() {
      const condition = {
        screen: this.screen,
        type  : this.type,
        needs : this.needs,
        mq    : this.forceMq,
        segments: {
          userCategory: this.$store.getters['banner/segments/userCategory'],
          schools: this.$store.getters['banner/segments/schools'],
          scorePer: this.$store.getters['banner/segments/scorePer'],
        },
      };

      ['screen', 'type'].forEach(key => {
        if (typeof condition[key] === 'string') {
          condition[key] = condition[key].replace(/\s/g, '').split(',');
        }
      });
      return condition;
    },
    firstIndexIsRandom() { return this.firstIndex === 'random' },
    isExist() { return this.count > 0 },
    visibleArea() { return this.visible.width * this.visible.height },
    isVisible() { return this.visibleArea >= this.visibilityJudge },
    _bcb_uid_() { return `bc-banner-${this._uid}` },
    currentItem() { return this.items.find(item => item.index === this.index ) },
  },

  watch: {
    mq() {
      if (!this.forceMq) this.onMq(this.mq);
    },
    count() {
      this.onExist(this.isExist);
      if (!this.isExist) {
        this.resetVisible();
      }
    },
    condition: {
      async handler() {
        const beforeIsPause = this.isPause;

        if (!this.isPause) this.pause();

        await this.fetch();

        requestAnimationFrame(() => {
          this.updateVisible();
          this.judgeVisibilityAndPause();
        });
      },
      deep: true,
    },
    index() {
      if (this.index === null || !this.currentItem) return;

      const item = this.currentItem;

      if (this.isVisible) {
        this.sendViewLog(item);
      } else {
        this.$once('visible', () => {
          this.sendViewLog(item);
        });
      }
    },
  },

  methods: {
    resetVisible() {
      this.visible.width  = 0;
      this.visible.height = 0;
    },
    sendLog(type, item) {
      return this.$store.dispatch('banner/data/sendLog', {type: type, item: item});
    },
    sendClickLog(item) {
      return this.sendLog('click', item);
    },
    sendViewLog(item) {
      return this.sendLog('view', item);
    },
    async fetch() {
      const items = await this.$store.getters['banner/data/search'](this.condition);
      const current = JSON.stringify(items);

      if (this._before === current) return;

      await this.emitCustomHook('beforeItemsUpdate');

      this.count   = items.length;
      this.index   = this.count === 0 ? null : this.firstIndexIsRandom ? Math.floor(Math.random() * this.count) : 0;
      this.items   = items;
      this._before = current;

      await new Promise((resolve, reject) => {
        this.$nextTick(async () => {
          await this.emitCustomHook('afterItemsUpdate');
          resolve();
        });
      });
    },

    emitCustomHook(name) {
      return new Promise((resolve, reject) => {
        this.$emit(name);
        if (typeof this[name] === 'function') {
          const promise = this[name]();
          if (promise && typeof promise === 'object' && typeof promise.then === 'function') {
            promise.then(resolve).catch(reject);
          } else {
            resolve(promise);
          }
        }
      });
    },

    clearBarrageSafeTimer() {
      if (this.barrageSafeTimerId !== null) {
        clearTimeout(this.barrageSafeTimerId);
        this.barrageSafeTimerId = null;
      }
    },

    async onItemClick(item, e) {
      if (this.clickDisabled) {
        e.preventDefault();
        return;
      }

      if (this.barrageSafeTimerId !== null) return;
      this.barrageSafeTimerId = setTimeout(() => {
        this.clearBarrageSafeTimer();
      }, BARRAGE_SAFE_INTERVAL);

      const targetIsSelf = !item.blankWindow || item.blankWindow === '_self';
      const url = item[`url_${this.mq}`];

      if (targetIsSelf) e.preventDefault();

      await this.sendClickLog(item);

      if (targetIsSelf) {
        location.href = url;
      }
    },

    updateVisible() {
      const rect = this.$el.getBoundingClientRect();
      const visible = {
        width : rect.width || 1,
        height: rect.height || 1,
      };

      const beforeIsVisible = this.isVisible;

      if (rect.top < 0) {
        visible.height += rect.top;
      }

      if (rect.bottom > this.$window.height) {
        visible.height -= rect.bottom - this.$window.height;
      }

      if (rect.left < 0) {
        visible.width += rect.left;
      }

      if (rect.right > this.$window.width) {
        visible.width -= rect.right - this.$window.width;
      }

      this.visible.width  = visible.width;
      this.visible.height = visible.height;

      if (this.isVisible !== beforeIsVisible) {
        this.$emit(this.isVisible ? 'visible' : 'hidden');
        this.$emit('visibilityChange', this.isVisible);

        if (this.expelFixed) {
          this.emitExpelFixedVisibledChangeForRoot(this.isVisible);
        }
      }
    },

    emitExpelFixedVisibledChangeForRoot(visible) {
      this.$root.$emit('expelFixedItemVisibledChange', {_uid: this._uid, visible: visible});
    },

    judgeVisibilityAndPause() {
      if (this.$window.isHide) return;
      if (this.isVisible) {
        this.resume();
      } else {
        this.pause();
      }
    },

    startVisibilityListeners() {
      this.updateVisible();

      // IE、EDGEで正しく初期値が取れない事があるのでウェイト
      setTimeout(() => {
        this.updateVisible();
      }, 500);

      this.$window.on(`resize.${this._bcb_uid_}`, () => {
        if (this.isPause) return;
        this.updateVisible();
      });
      this.$window.on(`scrollEnd.${this._bcb_uid_}`, () => {
        this.updateVisible();
      });
      this.$on('visibilityChange', isVisible => {
        this.judgeVisibilityAndPause();
      });
      this.judgeVisibilityAndPause();
    },

    stopVisibilityListeners() {
      this.$window.off(`resize.${this._bcb_uid_}`);
      this.$window.off(`scrollEnd.${this._bcb_uid_}`);
    },

    async startWindowVisibilityListeners() {
      if (this.$window.isHide) this.pause();
      await this.$window.ready();
      this.$window.on(`hide.${this._bcb_uid_}`, () => {
        this.pause();
      });
      this.$window.on(`show.${this._bcb_uid_}`, () => {
        this.resume();
        this.updateVisible();
      });
      this.startVisibilityListeners();
    },

    removeWindowListeners() {
      this.$window.off(`.${this._bcb_uid_}`);
    },

    pause() {
      if (this.isPause) return;
      this.isPause = true;
      if (typeof this.pauseAfter === 'function') {
        this.pauseAfter();
      }
    },

    resume() {
      if (!this.isPause) return;
      this.isPause = false;
      this.startVisibilityListeners();
      if (typeof this.resumeAfter === 'function') {
        this.resumeAfter();
      }
    },
  },

  created() {
    new EventManager(this);

    return new Promise(async (resolve, reject) => {
      this.fetch();
      await this.$nextTickPromise();
      await this.startWindowVisibilityListeners();
      this.emit('created');
    });
  },

  mounted() {
  },

  beforeDestroy() {
    this.emitExpelFixedVisibledChangeForRoot(false);
    this.removeWindowListeners();
    this.onBeforeDestroy();
    this.clearBarrageSafeTimer();
  },

  destroyed() {
    this.onDestroyed();
  },
}



// WEBPACK FOOTER //
// ./src/shared/bc-banner/mixins/banner.js